import { FormControl, FormLabel, Select } from '@chakra-ui/react';
import { useMemo } from 'react';
import { BookingJSON } from '../entities/Booking';
import { sortByDate } from '../utils/arrays';

interface Props {
  label?: string;
  placeholder: string;
  bookings: BookingJSON[];
  selected: number;
  onChange(bookingId: number): void;
  isDisabled?: boolean;
}

export function BookingSelect({ label, placeholder, bookings, selected, isDisabled, onChange }: Props) {
  const sortedBookings = useMemo(() => sortByDate(bookings, 'createdAt', 'desc'), [bookings]);

  return (
    <FormControl id="bookingId" isRequired>
      { label && <FormLabel>{label}</FormLabel> }

      <Select size="sm" name="bookingId" bg="white" onChange={e => onChange(Number(e.target.value))} defaultValue={selected || 0} isDisabled={isDisabled} placeholder={placeholder}>
        { sortedBookings.map(({ id, name }) => <option key={id} value={id}>{name}</option>) }
      </Select>
    </FormControl>
  );
}